import React from 'react';
import toast, { Toaster } from 'react-hot-toast';

import {confirmAlert} from "react-confirm-alert";
import Role from "../../inc/Role";
import {NavLink, useNavigate, useParams} from "react-router-dom";
import * as Icon from "react-bootstrap-icons";
import {Config} from '../../Config'
import * as Utils from "../../inc/Utils";
import DatePicker from "react-datepicker";
import Select from 'react-select' 
import moment from "moment-timezone";

export default function LeadFormCampaignDuplicate() {
    const roles = new Role();
    let userId = roles.loginUserId;

    //region duplicate
    let leadFormCampaignId = null;
    let {encode} = useParams();
    if(encode) {
        let decode = Utils.decodeItem(encode);
        leadFormCampaignId = decode.id;
    }
    //endregion

    let btnTextDefault = 'บันทึกข้อมูล';
    let btnTextLoading = 'กำลังบันทึก..';
    let [isLoading, setLoading] = React.useState(false);
    let [agency, setAgency] = React.useState('');
    let [agencyId, setAgencyId] = React.useState(null);
    let [createDate, setCreateDate] = React.useState('');  
    let [freeForm, setFreeForm] = React.useState('');

    let [campaign, setCampaign] = React.useState('');
    let [campaignId, setCampaignId] = React.useState(null);
    let [campaignSelectedId, setCampaignSelectedId] = React.useState(null);
    let [campaignName, setCampaignName] = React.useState(null);
    let [campaignPlaceholder, setCampaignPlaceholder] = React.useState('...');
    let [disableCampaignId, setDisableCampaignId] = React.useState(true);

    let [preview, setPreview] = React.useState('');
    let [view, setView] = React.useState('');

    const navigate = useNavigate();

    React.useEffect(() => {
        (async function() {
            try {
                const resAgency = await Utils.getAgencySlug({agencyId: roles.permissionId === Utils.SUPER_ADMIN_ID ? null : roles.agencyId});
                setAgency(resAgency);

                const resView = await getView(leadFormCampaignId);
                if(resView) {
                    setView(resView);

                    if(resAgency) {
                        for(let ln of resAgency) {
                            if(ln.slug === resView.agencyId) {
                                setAgencyId({id: ln.id, slug: ln.slug});
                                break;
                            }
                        }
                    }

                    setCreateDate(new Date(resView.createDate));
                    setFreeForm(resView.freeForm);
                    setCampaignId(resView.campaignId);
                    setCampaignName(Utils.removeSpaceUnderScore(resView.campaignName));

                    setCampaignPlaceholder('กำลังโหลด...');
                    const resCampaign = await Utils.getListSubCampaign();
                    if(resCampaign) {
                        let campaignList = resCampaign.campaign;
                        if(campaignList) {
                            let newCampaign = [];
                            for(let rs of campaignList) {
                                newCampaign.push({
                                    campaign_id: rs.sub_campaign_id,
                                    campaign_name: rs.sub_campaign_name
                                })
                            }
                            setCampaign(newCampaign);
                            setCampaignPlaceholder('Select...');
                            setDisableCampaignId(false);
                        }

                        for(let pt of campaignList) {
                            if(resView && resView.campaignId && pt.sub_campaign_id === resView.campaignId) {
                                setCampaignSelectedId({
                                    campaign_id: pt.sub_campaign_id,
                                    campaign_name: pt.sub_campaign_name
                                });
                                break;
                            }
                        }
                    }
                }

            } catch (e) {
                toast.error(e.message);
            }
        })();
    }, []);

    //region duplicate
    async function getView(id) {
        const response = await fetch(Config.url.API_URL +'/api/leadFormCampaign/view', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': roles.accessToken
            },
            body: JSON.stringify({
                id: id
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }
    //endregion

    const onCreate = async () => {

        let param = await getParams();

        if(!campaignId) {
            toast.error("กรุณาระบุ Campaign Id");
        }
        else if(!campaignName) {
            toast.error("กรุณาระบุ Campaign Name");
        }
        else if(!agencyId) {
            toast.error("กรุณาระบุ Agency");
        }
        else if(!createDate) {
            toast.error("กรุณาระบุ Create Date");
        }
        else if(freeForm && freeForm.includes(' ')) {
            toast.error("Free Form ห้ามมีช่องว่าง");
        }
        else if(freeForm && freeForm.includes('_')) {
            toast.error("Free Form ห้ามมี _");
        }
        else if(param.length <=0 || param.length >= 300) {
            toast.error("ขนาดตัวอักษรต้องไม่เกิน 300");
        }
        else {
            confirmAlert({
                title: 'แจ้งเตือน',
                message: 'ต้องการบันทึกข้อมูล ?',
                buttons: [
                    {
                        label: 'ตกลง',
                        onClick: () => {
                            setLoading(true);

                            const body = {
                                campaignId: campaignId ? campaignId : null,
                                campaignName: campaignName ? campaignName : null,
                                createDate: createDate ? new Date(createDate) : null,
                                agencyId: agencyId ? agencyId.slug : null,
                                freeForm: freeForm ? freeForm : null,
                                createdBy: userId,
                                createdAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
                                updatedAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
                            };

                            fetch(Config.url.API_URL +'/api/leadFormCampaign/create', {
                                method: 'POST',
                                body: JSON.stringify(body),
                                headers: {
                                    'Content-Type':'application/json',
                                    'x-access-token': roles.accessToken
                                }
                            }).then(response => {
                                setLoading(false);
                                if(response.ok) {
                                    return response.json();
                                }
                                else {
                                    return response.json().then(err => Promise.reject(err));
                                }
                            }).then(result => {
                                if(result) {
                                    toast.success("บันทึกข้อมูลเรียบร้อย");
                                    setTimeout(function () {
                                        navigate('/leadFormCampaign', {replace: true});
                                    }, 1500);
                                }
                            }).catch(err => {
                                toast.error(err.message);
                            })
                        }
                    },
                    {
                        label: 'ยกเลิก',
                        onClick: () => {}
                    }
                ]
            });
        }
    };

    const onChangeAgencyId = (obj) => {
        setAgencyId(obj);
    };
    const onChangeCreateDate = async (value) => {
        setCreateDate(value);
    };
    const onChangeCampaignId = (obj) => {
        setCampaignSelectedId(obj);
        setCampaignId(obj.campaign_id);
        setCampaignName(Utils.removeSpaceUnderScore(obj.campaign_name));
        document.getElementById("campaignName").value = Utils.removeSpaceUnderScore(obj.campaign_name);
    };
    const onPreviewUTM = async () => {
        const param = await getParams();
        setPreview(param);
    };

    async function getParams() {
        // Format : {"{Campaign ID}_{Agency}_{Campaign Name}_{Create Date}_{Free Form}_[ST]"}
        // ตัวอย่าง : 70092_MS_Apitownudonthani1_30Sep2023_Apdata_[ST]

        let date = new Date(createDate);
        let newCreateDate = date.getDate() + '' + Utils.monthNames[date.getMonth()] + '' + date.getFullYear();

        let param = campaignId + '_' + agencyId.slug + '_' + campaignName + '_' + newCreateDate;
        if(freeForm) {
            param += '_' + Utils.removeSpaceUnderScore(freeForm);
        }
        param += '_[ST]';

        return param;
    }

    return (
        <main>
            <div className="row table-toolbar mb-2">
                <div className="col-6 align-self-center">
                    <div className="h6 d-inline"><span className="text-success">&#8226;</span> Lead Form Campaign</div>
                    <span className="ms-1">/</span> <span className="text-muted">Create</span>
                </div>
                <div className="col-6 text-end align-self-center toolbars">
                </div>
            </div>
            <div className="rounded bg-white p-4 shadow">
                <div className="row">
                    <div className="col-12 col-md-7">
                        <div className="d-block mb-1 small">{"{Campaign ID}_{Agency}_{Campaign Name}_{Create Date}_{Free Form}_[ST]"}</div>
                        <form>
                            <div className="row g-3 border rounded bg-light p-2 mt-0 mb-3">
                                <div className="col-12">
                                    <label htmlFor="campaignId" className="form-label">Campaign ID <span className="text-danger">*</span></label>
                                    <Select
                                        isClearable={true}
                                        isDisabled={disableCampaignId}
                                        classNamePrefix="form-select-search"
                                        placeholder={campaignPlaceholder}
                                        options={campaign}
                                        onChange={(event) => onChangeCampaignId(event)}
                                        value={campaignSelectedId}
                                        getOptionValue={(option) => `${option.campaign_id}`}
                                        getOptionLabel={(option) => `${option.campaign_id} : ${option.campaign_name}`}
                                    />
                                </div>
                            </div>
                            <div className="row g-3 border rounded bg-light p-2 my-3">
                                <div className="col-12 mt-1">
                                    <label htmlFor="agency" className="form-label">Agency <span className="text-danger">*</span></label>
                                    <Select
                                        isClearable={true}
                                        classNamePrefix="form-select-search"
                                        options={agency}
                                        onChange={(event) => onChangeAgencyId(event)}
                                        value={agencyId}
                                        getOptionValue={(option) => `${option.id}`}
                                        getOptionLabel={(option) => `${option.slug}`}
                                    />
                                </div>
                            </div>

                            <div className="row g-3 border rounded bg-yellow-light p-2 my-3">
                                <div className="col-12 mt-1">
                                    <label htmlFor="campaignName" className="form-label">Campaign Name <span className="text-danger">*</span></label>
                                    <div className="css-b62m3t-container"><input className="form-control" type="text" id="campaignName" name="campaignName" onKeyUp={e => {
                                        if(e && e.target.value) {
                                            setCampaignName(Utils.removeSpaceUnderScore(e.target.value));
                                        }
                                        else {
                                            setFreeForm('');
                                        }
                                    }} defaultValue={campaignName} onBlur={e => {
                                        setCampaignName(e.target.value ? Utils.removeSpaceUnderScore(e.target.value) : '');
                                        document.getElementById("campaignName").value = Utils.removeSpaceUnderScore(e.target.value);
                                    }} /></div>
                                </div>
                            </div>

                            <div className="row g-3 border rounded bg-light p-2 my-3">
                                <div className="col-12 mt-1">
                                    <label htmlFor="createDate" className="form-label">Create Date <span className="text-danger">*</span></label>
                                    <DatePicker
                                        selected={createDate}
                                        onChange={(date) => onChangeCreateDate(date)}
                                        dateFormat="yyyy-MM-dd"
                                        wrapperClassName="w-100"
                                        className="form-control" />
                                </div>
                            </div>

                            <div className="row g-3 border rounded bg-yellow-light p-2 my-3">
                                <div className="col-12 mt-1">
                                    <label htmlFor="createDate" className="form-label">Free Form</label>
                                    <div className="css-b62m3t-container"><input className="form-control" type="text" id="freeForm" name="freeForm" onKeyUp={e => {
                                        if(e && e.target.value) {
                                            setFreeForm(e.target.value);
                                        }
                                    }} defaultValue={freeForm} onBlur={e => {
                                        setFreeForm(e.target.value ? Utils.removeSpaceUnderScore(e.target.value) : '');
                                        document.getElementById("freeForm").value = e.target.value ? Utils.removeSpaceUnderScore(e.target.value) : '';
                                    }} /></div>
                                </div>
                            </div>

                            <div className="row g-3 border rounded bg-green-light p-2 my-3">
                                <div className="col-12 mt-0">
                                    <label htmlFor="preview" className="form-label"><button type="button" className="btn btn-sm btn-light" onClick={onPreviewUTM} disabled={!agencyId || !campaignId}>Preview</button></label>
                                    <div className="noselect-url w100 rounded">{preview}</div>
                                    <p className="mt-2 mb-0">ตัวอักษร : {preview.length}</p>
                                </div>
                            </div>

                            <div className="row g-3">
                                <div className="col-12">
                                    <button type="button" className="btn btn-primary" onClick={onCreate}><span
                                        className={isLoading ? 'spinner-grow spinner-grow-sm' : 'd-none'}></span> {isLoading ? btnTextLoading : btnTextDefault}</button>
                                    <NavLink className="btn btn-sm btn-light ms-2" to='/leadFormCampaign'><span><Icon.ArrowLeft/> กลับไป</span></NavLink>
                                    <Toaster position="bottom-right" />
                                </div>
                            </div>
                        </form>
                    </div>
                    <div className="col-12 col-md-6"></div>
                </div>
            </div>
        </main>
    );
}